import React, {Component} from 'react';
import PropTypes from 'prop-types';
class NavPointMenu extends Component {
	render() {
		return (
			<div className={'nav-point-menu-container'}>
				{this.props.options.map((opt, index) => (
					<div key={index} className={'option-point' + (opt.id === this.props.activeOption ? ' active' : '') + (opt.disabled || opt.noClick ? ' disabled' : '')}>
						<div className={'point-container'}>
							{index > 0 ? <div className={'line-connector left'} /> : null}
							<div className={'point'} onClick={opt.disabled || opt.noClick ? null : opt.onClick} />
						</div>
						<div className={'text'} onClick={opt.disabled || opt.noClick ? null : opt.onClick}>
							{opt.label}
						</div>
					</div>
				))}
			</div>
		);
	}
}
NavPointMenu.propTypes = {
	options: PropTypes.array.isRequired,
};
export default NavPointMenu;
